Customer.Filters ||= {}

class Customer.Filters.FilterFolderView extends Backbone.View
  template: JST['backbone/templates/customer/filters/filter_folder']
  rootFolderTemplate: JST['backbone/templates/customer/filters/root_folder']
  className: 'filter-folder-container'
  events:
    'click > dt': '_openFolderAndUpdateCounters'
    'click .filter-folder-edit': 'edit'
    'click .filter-folder-delete': 'delete'

  initialize: (@options = {}) ->
    @filterFolder = @options.filterFolder
    @filterListView = @options.filterListView || throw new Error('Cannot instantiate a FilterFolderView without a FilterListView')
    @canManage = @options.canManage
    @canManageGlobal = @options.canManageGlobal
    @canSort = @options.canSort
    @filterEventHandler = new Customer.Dashboard.FilterEventHandler(@filterFolder)
    @listenTo(@filterFolder, 'change', @render)

  render: ->
    @_renderTemplate()
    @_renderChildren()
    _.defer @_renderTooltip
    @

  _renderTemplate: ->
    if @filterFolder.isRoot()
      @$el.html @rootFolderTemplate
        filterFolder: @filterFolder
        nonEditable: not @_isEditable()
        canSort: @canSort
    else
      @$el.html @template
        filterFolder: @filterFolder
        nonEditable: not @_isEditable()
        canSort: @canSort

  _isEditable: ->
    return @canManageGlobal if @filterFolder.isGlobal()
    @canManage

  _renderChildren: ->
    $DOM = @$el.find("##{@filterFolder.get('id')}")
    _.each @filterFolder.get('children'), (child) =>
      if child.isFilter()
        child.markAsUnread()
        @filterListView.renderFilter(child, $DOM)
      else
        @filterListView.renderFilterFolder(child, $DOM)

  _renderTooltip: =>
    $filterName = @$el.children('dt').find('.filter-name')
    return unless @_hasOverflow($filterName)
    $filterName.attr('title', $filterName[0].innerText)

  _hasOverflow: ($selector) ->
    $selector[0]?.offsetWidth < $selector[0]?.scrollWidth

  open: ->
    @$el.toggleClass('open')
    @filterFolder.set('open', @$el.hasClass('open'))

  _openFolderAndUpdateCounters: ->
    @_keepCustomerSessionAlive()
    @open()
    @filterEventHandler.forcedUpdateCounters()

  edit: (event) ->
    event.stopPropagation()
    @trigger('edit', @filterFolder)

  delete: (event) ->
    event.stopPropagation()
    @trigger('delete', @filterFolder)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
